// removed by extract-text-webpack-plugin
module.exports = {"modal-header":"app-pages-Inventory-PurchaseOrder-FormPurchaseOrder-ConfirmSubmitModal-__ConfirmSubmitModal___2U8ax","modal-dialog":"app-pages-Inventory-PurchaseOrder-FormPurchaseOrder-ConfirmSubmitModal-__ConfirmSubmitModal___R8LGY"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Inventory/PurchaseOrder/FormPurchaseOrder/ConfirmSubmitModal/ConfirmSubmitModal.css
// module id = 2379
// module chunks = 0